import React from 'react';
import { getProductClass, getProductKey } from './catalog';

// Memoizacja: sekcja przelicza się tylko przy realnej zmianie propsów
// (section pochodzi z modułu, addToRefs jest stabilne przez useCallback).
const ProductSection = React.memo(function ProductSection({ section, addToRefs }) {
  const { id, title, products } = section;

  return (
    <div className="collection-subsection" id={section.id}>
      <h3 className="subsection-title reveal" ref={addToRefs}>{title}</h3>
      <div className="premium-line-divider"></div>

      <div className="products-list-grid reveal" ref={addToRefs}>
        {products.map((product) => (
          <a
            key={product.id}
            href={`#produkt/${getProductKey(id, product)}`}
            className={`store-product-card ${getProductClass(product.name)}`}
          >
            <div className="card-image-box">
              <img src={product.img} alt={product.name} loading="lazy" decoding="async" />
            </div>
            <div className="card-info-box">
              <h4>{product.name}</h4>
              <div className="line-separator"></div>
              {product.tagline && <span className="card-tag">{product.tagline}</span>}
            </div>
          </a>
        ))}
      </div>
    </div>
  );
});

export default ProductSection;
